import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Container = styled.div`
    display: flex;
    flex-direction: column;
`

// const Title = styled.div`
//     font-weight: bolder;
// `

// const Subtitle = styled.div`
//     font-size: 0.9rem;
//     filter: brightness(var(--brightness));
// `


const Title = styled.div`
    font-size: 0.9rem;
    font-weight: bold;
    align-self: end;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;
    width: 100%;
`

const Subtitle = styled.div`
    font-size: 0.8rem;
    align-self: start;
    margin-top: 0.1rem;
`

const ToastBlock = props => {
    const {
        title,
        subtitle,
        onSelect
    } = props

    return (
        <Container onClick={onSelect}>
            <Title>{title}</Title>
            <Subtitle>{subtitle}</Subtitle>
        </Container>
    )
}

export default ToastBlock;

ToastBlock.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string
}
